import React, {useState, useEffect} from 'react'
import {v4 as uuid} from 'uuid'
import { 
    SummaryProductListContainer, 
    SummaryProductImage, 
    SummaryProductInfo, 
    SummaryDeleteProduct, 
    SummaryLoadContainer, 
    TitleList,
    RowProductListContainer 
} from './style'
import Spinner from '../../components/Spinner';
import QuantityCounter from '../../components/QuantityCounter'
import {getCategoryname} from '../../utils/getNameById'
import useView from '../../hooks/useView'
import { RootState } from "../../redux/reducers/index";
import { useDispatch, useSelector } from "react-redux";
import {isSummaryPage, updateQuantityCounter } from '../../redux/actions/shoppingCartActions'
import { handleRequestQuote, handleResetQuote, handleOnchangeDefaultCity, handleLoadEditProd, handleRefProductEdit } from '../../redux/actions';
import CurrencyFormat from '../../utils/currencyFormat';
import config from "../../config/enviroment";
import { shouldShowMarcaBlancaModal } from "../MarcaBlancaModal/shouldShow";
import { getCartUnits } from "../../utils/marcaBlancaCart";
import { calculatePriceWithTax, formatDate, returnProduct } from '../../utils/formatData'
import CornerRibbon from 'react-corner-ribbon';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './styles.css'; 
import { language } from '../../utils/language';
import { catalogueUrlSegment } from '../../utils/catalogueUrl';


interface ISummaryProductList{
    data: Array<any>,
    color: string,
    loading: boolean,
    onDelete: any,
    history: any,
    catalogueName: string,
    categoryList: Array<any>
}


export const SummaryProductList = ({data, color, loading, onDelete, history, catalogueName, categoryList}: ISummaryProductList) => {
    
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    const elogisticaState: any = useSelector((state: RootState) => state.elogistica);
    const clientState: any = useSelector((state: RootState) => state.client);
    const marcaBlancaState: any = useSelector((state: RootState) => state.marcaBlanca);
    const isMarcaBlancaStore = shouldShowMarcaBlancaModal(clientState?.id, config.marcaBlancaId);
    const marcaBlancaMaxUnits = marcaBlancaState.client?.maxDataphoneUnits ?? 0;
    const marcaBlancaRowMax = (currentQty: number) =>
        marcaBlancaMaxUnits - (getCartUnits(data) - currentQty);
    const [currentPosition, setCurrentPosition] = useState<number>(0)
    const {display} = useView()
    const dispatch = useDispatch()
    const [items, setItems] = useState<any>([])
    const [showComponent, setShowComponent] = useState(true);

    const [isMobile, setIsMobile] = useState(false);
    const [isIphone, setIsIphone] = useState(false);


    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 992);
        setIsIphone(window.innerWidth < 430);
      };
  
      window.addEventListener('resize', handleResize);
  
      handleResize();
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  

    useEffect(() => {
        const productsRefs= data.filter((item: any) => item.references && item.references.length > 0)
        const productsData = data.filter((item: any) => !(item.references && item.references.length > 0))
        if (productsRefs.length > 0) {
            productsRefs.map((product: any) => {
                product.references.map((itemRef: any) => {
                    itemRef.data = product.productData.references.find( (field: any) => field.id === itemRef.id)
                    productsData.push({ ...product, references: [itemRef] })
                })    
            })
        }
        setItems(productsData)

    }, [data])
    
    

    const handleRedirectProductInfo = (idCategory: number | string, idProduct: number, position: string, product: any) => {
        if (homeState.epaycoDeliveryProvider && product.operator !== "") {
            dispatch(handleResetQuote())
            dispatch(handleOnchangeDefaultCity({...elogisticaState.selectedCity, trans: product.operator}))
            const payload = {
                operador: product.operator,
                id_configuracion: homeState.pickupConfigurationId,
                ciudad_destino: elogisticaState.selectedCity.codigoDane,
                valor_mercancia: product.productData.declaredValue,
                fecha_guia: formatDate(new Date()),
                envio: [
                    {
                        cantidad_unidades: product.quantity,
                        peso_real: Math.round(product.productData.realWeight) === 0 ? 1 : Math.round(product.productData.realWeight),
                        alto: product.productData.high,
                        largo: product.productData.long,
                        ancho: product.productData.width
                    }
                ]
            }
            dispatch(handleRequestQuote(payload))
        }
        const categoryName = getCategoryname(idCategory, categoryList, homeState.default_language)
        history.push(`/vende/${catalogueUrlSegment(catalogueName)}/product-info/${categoryName}/${idProduct}/${position}`)
    }

    const unitFormats = {
        one: display === "mobile" ? 'ud' : language[homeState.default_language]["unit"],
        more: display === "mobile" ? 'uds' : language[homeState.default_language]["units"],
    }

    
    const mappingImgRef = (img: string, imgProduct: string) => {
        return img !== "" ? img : imgProduct
    }

    const returnProductQuantity = (product: any) => {
        
        if (product.references && product.references.length > 0) {
        
            return  product.references[0].quantity 
        }


        return product.quantity
    }
    
    const handleUpdateQuantityCounter = (props: any) => {
        const { value, idProduct, idProductRef } = props
        let dataAux = [...data]
        const productDataIndex = data.findIndex((item: any) => item.id === idProduct)
        let productDataRefIndex = null
        if (data[productDataIndex].references && data[productDataIndex].references.length > 0) {
            productDataRefIndex = data[productDataIndex].references.findIndex((item: any) => item.id === idProductRef)
            dataAux[productDataIndex].references[productDataRefIndex].quantity = value
        } else {
            dataAux[productDataIndex].quantity = value
        }
        dispatch(updateQuantityCounter(dataAux))
        setShowComponent(true);
    }


    const totalQuantityPrice = (product: any, field: string = 'amount') => {
        if (product.references && product.references.length > 0) {
            return product.references[0].data[field] * product.references[0].quantity;
        } else {
            return product.productData[field] * product.quantity;
        }
    };
    

    const findAmountProduct = (product: any, field: string | null = 'amount') => {

        if (product.references && product.references.length > 0) {
            const reference = product.references[0].data

        

            if (field !== null && reference) {


                if(field=="available")
                {
                    return parseInt(reference?.[field]) + parseInt(product.references[0].initialQuantity);
                }


                return reference?.[field]
            }

            if(field !== null && field=="available")
                {
                    return parseInt(reference) + parseInt(product.references[0].initialQuantity);
                }
            return reference
        }

          if(field !== null && field=="available")
            {

                return parseInt(product.productData[field]) + parseInt(product.initialQuantity);
            }
        return field !== null ? product.productData[field] : product.productData
    }

    const getImageSrc = (product: any, mappingImgRef: Function) => {
        if (product.references && product.references.length > 0 && !product.references[0].data.img.endsWith('/null')) {
          return mappingImgRef(product.references[0].data.img, product.productData.img[0]) || product.productData.img[0];
        } else {
          return product.productData.img[0];
        }
      }


    return (

        <SummaryProductListContainer>
            <RowProductListContainer>
                <SummaryProductImage >
                  <div id='summary-product-image-header'>
                     {language[homeState.default_language]["space"]}
                  </div>
                </SummaryProductImage>
                <div className='summary-product-row-header-titles'>
                  <TitleList>
                      <div>{language[homeState.default_language]["product"]}</div>
                      <div>{language[homeState.default_language]["amount"]}</div>
                      <div>{language[homeState.default_language]["price"]} </div>
                      <div>{language[homeState.default_language]["total"]}</div>
                  </TitleList>
                </div>
                <SummaryDeleteProduct color={color}>
                    {' '}
                </SummaryDeleteProduct>
            </RowProductListContainer>
            <TransitionGroup>
            {  
                items.map( (product: any, index: number ) => (    
                    <CSSTransition
                    key={uuid()}
                    timeout={300}
                    classNames="fade"
                    unmountOnExit
                    >         
                    <RowProductListContainer id='product-row' key={uuid()}>
                        
                        {
                            
                            loading  && product.position === currentPosition ?

                            <SummaryLoadContainer>
                                <Spinner color={color}/>
                            </SummaryLoadContainer>

                            :
                            <>
                                <SummaryProductImage>
                                <div id='summary-product-cart-image'>
                                <img 
                                    src={getImageSrc(product, mappingImgRef)} 
                                    alt={getImageSrc(product, mappingImgRef)}
                                    onClick={() => handleRedirectProductInfo(product.productData.categories[0], product.id, product.position, product)}
                                />
                                {
                                    (product.references && product.references.length > 0 && product.references[0].data.discountRate > 0) || ((!product.references || product.references.length === 0) && product.productData.discountRate > 0) ?
                                        <CornerRibbon backgroundColor="#ff0000" fontColor="#f0f0f0" containerStyle={{}}>
                                        <span style={{fontFamily: 'Roboto', fontWeight: 700, fontSize: `${isIphone ? '0.65em' : '0.85em'}`}}>
                                        {' '}{product.references && product.references.length > 0 ? product.references[0].data.discountRate : product.productData.discountRate}%off
                                          </span>
                                      </CornerRibbon>
                                    
                                    : null
                                }
                                </div>
                                </SummaryProductImage>
                                <SummaryProductInfo hasDiscount={findAmountProduct(product, "discountRate") > 0}>
                                    <div className="summary-product-title">
                                        <div className='summary-product-title-text__container'>
                                            <p>{product.productData.title}</p>

                                            { product.references && product.references.length > 0 && 

                                            <div className="summary-product-subTitle">
                                            <p className="summary-product-reference-title">{product.references[0].data.title}</p>
                                            </div>}
                                            {
                                                    homeState.epaycoDeliveryProvider && product.operator !== "" &&
                                                    <div className='shipping-operator__container'>
                                                        <p className="shipping-operator">{language[homeState.default_language]["methodShipping"]}:</p>
                                                        {`${product.operator === '472' ? '4-72' : product.operator}`.toUpperCase()}
                                                    </div>
                                            }    
                                        </div>
                                    </div>
                                    <div className="summary-product-title">
                                        <QuantityCounter   
                                            value={returnProductQuantity(product)}
                                            setValue={(value: number) => {
                                                handleUpdateQuantityCounter({ value, idProduct: product.id, idProductRef: findAmountProduct(product, "id") })
                                            }} 
                                            inneredge={true}
                                            available={isMarcaBlancaStore
                                                ? Math.min(findAmountProduct(product, "available"), marcaBlancaRowMax(returnProductQuantity(product)))
                                                : findAmountProduct(product, "available")}
                                            color={color}
                                        />     
                                    </div>
                                        {
                                           findAmountProduct(product, "discountRate") > 0 ?
                                            <div className='summary-product-prices'>
                                                <div className="summary-product-discount">
                                                <span className={`${isMobile ? 'mobile-only' : 'hide-on-mobile'} mobile-width`}>Precio: </span> 
                                                <div id='Mobile-price-canceled' className={`${isMobile ? 'mobile-only' : 'hide-on-mobile'} summary-product-normalPrice-canceled` }>
                                                <CurrencyFormat  amount={findAmountProduct(product, "netAmount") !== 0 ? calculatePriceWithTax(findAmountProduct(product, null)) : findAmountProduct(product)} />
                                                </div>
                                                    <CurrencyFormat amount={findAmountProduct(product)}  />
                                                </div>

                                                <div className={`${isMobile ? 'hide-on-mobile' : 'mobile-only'} summary-product-normalPrice-canceled`}>
                                                <CurrencyFormat amount={findAmountProduct(product, "netAmount") !== 0 ? calculatePriceWithTax(findAmountProduct(product, null)) : findAmountProduct(product)} />
                                                </div>   

                                            </div>
                                            :
                                            <div className="summary-product-normalPrice">
                                                <span className={`${isMobile ? 'mobile-only' : 'hide-on-mobile'} mobile-width`}>Precio: </span>
                                                <CurrencyFormat amount={findAmountProduct(product)} />
                                            </div>
                                        }
                                    
                                    <div className='summary-total-prices'>
                                        <div className="summary-product-total">
                                        <span  className={`${isMobile ? 'mobile-only' : 'hide-on-mobile'} mobile-width`}>{language[homeState.default_language]["total"]}: </span>
                                        <CurrencyFormat amount={(totalQuantityPrice(product, "amount"))} />
                                         </div>
                                    </div>
                                </SummaryProductInfo>
                                    <SummaryDeleteProduct color={color}>
                                        <img src={`${config.urlMultimedia}/vende/landing-img/TrashIcon.png`} alt='Delete Icon' onClick={ ()=> { 
                                            if(loading){
                                                return null
                                            }
                                            else{
                                                onDelete(product.position, items.length === 1, product.references && product.references.length > 0 ? product.references[0].id : "", product.id); 
                                                dispatch(isSummaryPage(false))
                                                setShowComponent(false)
                                                setCurrentPosition(product.position)
                                            }                                                                                
                                            }}
                                        />
                                        
                                </SummaryDeleteProduct>
                            </>
                        }
                        
                    </RowProductListContainer>
                </CSSTransition>
                ))
             }
            </TransitionGroup>
        </SummaryProductListContainer>
    )
}